import React from "react";
import { Col, Row, UiCenter, UiImage, UiText } from "~/components/elements";
import blueCircleChecked from "~/assets/img/v2/blue_circle_checked.png";
import circleUnchecked from "~/assets/img/v2/cirlcle_unchecked.png";
import { useAppSelector } from "~/hooks";

export interface SelectableItem {
  id: string | number;
  headshot_style_id?: string | number;
  name: string;
  preview_photo_url?: string;
  man_preview_photo_url?: string;
  woman_preview_photo_url?: string;
  all_access_only?: boolean;
}

export interface SelectableGridProps<T extends SelectableItem> {
  items: T[];
  selectedItems?: T[] | null;
  selectedItem: T | null;
  onItemClick: (item: T) => void;
  containerHeight?: string;
}

const BLACK_ITEMS = ["White Office Shirt", "Studio - White"];

export function SelectableGrid<T extends SelectableItem>({
  items,
  selectedItem,
  selectedItems,
  onItemClick,
  containerHeight = "7rem",
}: SelectableGridProps<T>) {
  const user = useAppSelector(state => state.auth.currentUser || {});
  return (
    <Col rounded="20px" w="full">
      <Row flexWrap="wrap" gap={{ base: 2, sm: 3 }} w="full" minHeight={containerHeight} pb={2}>
        {items?.map(item => {
          const disableSelect = !user.is_all_access_plan && item.all_access_only;
          const isSelected = selectedItem?.id === item.id;
          const isSelectedSomewhere =
            !isSelected &&
            item?.headshot_style_id &&
            selectedItems?.findIndex(s => s.headshot_style_id === item.headshot_style_id) !== -1;

          return (
            <Col
              key={item.id}
              borderWidth="2px"
              borderColor={isSelected ? "blue" : "transparent"}
              // flexShrink="0"
              w={{ base: "9.375rem", sm: "11.8rem" }}
              h={{ base: "9.375rem", sm: "11.8rem" }}
              // aspectRatio={1}
              borderRadius="22px"
              opacity={isSelectedSomewhere ? 0.3 : 1}
              _hover={{ cursor: isSelectedSomewhere ? "not-allowed" : "pointer" }}
              onClick={e => {
                if (disableSelect || isSelectedSomewhere) {
                  e.preventDefault();
                  return;
                }
                onItemClick(item);
              }}
              pos="relative"
            >
              <Col pos="absolute" top={2} right={2}>
                {isSelected || isSelectedSomewhere ? (
                  <UiImage src={blueCircleChecked} width="5" mx={0} />
                ) : (
                  <UiImage src={circleUnchecked} width="5" mx={0} />
                )}
              </Col>
              {item.all_access_only && (
                <UiCenter
                  pos="absolute"
                  left={0}
                  right={0}
                  top={0}
                  bg="#ABD439"
                  borderTopLeftRadius="20px"
                  borderBottomRightRadius="20px"
                  borderColor="white"
                  borderBottomWidth="1px"
                  borderRightWidth="1px"
                  w="9.1875rem"
                  h="1.5rem"
                  pt="2px"
                >
                  <Row align="center">
                    <UiText textAlign="center" noOfLines={1} vr="body3" fontWeight="bold">
                      ALL ACCESS PLAN&nbsp;
                    </UiText>
                    <UiText as="span" fontSize="11px" mb="2px">
                      ⭐
                    </UiText>
                  </Row>
                </UiCenter>
              )}
              <UiImage
                src={item.preview_photo_url || item.man_preview_photo_url || item.woman_preview_photo_url || ""}
                containerClasses="flex1 h-full"
                h="full"
                w="full"
                objectFit="cover"
                borderRadius="20px"
              />
              <Row pos="absolute" left={0} right={0} bottom={0} px={2} pb={2}>
                <UiText
                  textAlign="left"
                  noOfLines={2}
                  color={BLACK_ITEMS.includes(item.name) ? "black" : "white"}
                  vr="title2"
                >
                  {item.name}
                </UiText>
              </Row>
            </Col>
          );
        })}
      </Row>
    </Col>
  );
}
